import React, { useEffect, useState } from "react";
import registerImage from "../Assets/registerImage.jpg";
import paintBrush from "../Assets/paintBrush.jpg";

import { db,auth } from "../Config/firebase.js";
import { addDoc,collection } from "firebase/firestore";
import {createUserWithEmailAndPassword} from "firebase/auth";
// import { auth } from "../Config/firebase";


const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pswd, setPswd] = useState("");
  const [address, setAddress] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessagePswd, setErrorMessagePswd] = useState("");



  const userDetails=collection(db, 'userdetails');

useEffect(()=>{
    console.log(name,email,pswd,address);
    console.log({db});
},[name,email,pswd,address])

  const signUp = async () => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, pswd);
      const user = userCredential.user;
      console.log('user',user);
      await addDoc(userDetails, {
        uid: user.uid,
        name,
        email,
        password:pswd,
        address
      });

      alert("Your account is created");
    } catch (error) {
      switch (error.code) {
        case "auth/email-already-in-use":
          setErrorMessage("This email is already in use.");
          break;
        case "auth/weak-password":
          setErrorMessagePswd("Password should be at least 6 characters.");
          break;
        case "auth/invalid-email":
          setErrorMessage("Invalid email format.");
          break;
        case "auth/missing-email":
          setErrorMessage("Please fill the email.");
          break;
        case "auth/missing-password":
          setErrorMessagePswd("Please fill the password.");
          break;
        default:
          setErrorMessage("An error occurred: " + error.message);
      }
    }

    setName("")
    setEmail("")
    setPswd("")
    setAddress("")
  };


// const signUp = async () => {
//     try {
//       await createUserWithEmailAndPassword(auth, email, pswd);
//       alert("Your account is created");
//       localStorage.setItem('email',email)
//       localStorage.setItem('pswd',pswd)
//     } catch (error) {
//       switch (error.code) {
//         case "auth/email-already-in-use":
//           setErrorMessage("This email is already in use.");
//           break;
//         case "auth/weak-password":
//           setErrorMessagePswd("Password should be at least 6 characters.");
//           break;
//         case "auth/invalid-email":
//           setErrorMessage("Invalid email format.");
//           break;
//         case "auth/missing-email":
//           setErrorMessage("Please fill the email.");
//           break;
//         case "auth/missing-password":
//           setErrorMessagePswd("Please fill the password.");
//           break;
//         default:
//           setErrorMessage("An error occurred: " + error.message);
//       }
//     }
//   };


//  const postUser=async()=>{
//     await addDoc(userDetails,{
//         name,
//         email,
//         password:pswd,
//         address
//     })
//     setName("")
//     setEmail("")
//     setPswd("")
//     setAddress("")
//  }
  return (
    <div className="register">

      <div className="registerImage">
        <img className="image" src={paintBrush} />
      </div>

      <div className="RegisterForm">
        <h1>Register</h1>
        <p className="inputLabel">Name</p>
        <input
          type="text"
          className="input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Enter your name"
        />
        <p className="inputLabel">Email Address</p>
        <input
          type="email"
          className="input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
        />
        {errorMessage && <p className="text-danger">{errorMessage}</p>}
        <p className="inputLabel">Password</p>
        <input
          type="password"
          className="input"
          value={pswd}
          onChange={(e) => setPswd(e.target.value)}
          placeholder="Enter your password"
        />
        {errorMessagePswd && <p className="text-danger">{errorMessagePswd}</p>}

        <p className="inputLabel">Address</p>
        <textarea
          style={{ height: "140px" }}
          className="input"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          placeholder="Enter your address here..."
        />

        <button type="submit" className='loginBtn' onClick={signUp}>
            Register
        </button>
      </div>

      <div className="registerImage">
        <img className="image" src={registerImage} />
      </div>
    </div>
  );
};

export default Register;
